import { useExamCenter } from '@exam-center/admin-exam-center-details';
import { FilterOperator, useAdminSearchExamCenterCoursesQuery } from '@exam-center/graphql';
import { useMemo } from 'react';

import { ExamCenterExamCourseDataGrid } from '../../components';
import { useExamCenterExamCourseListSearchParams } from '../../hooks';
import { NoExamCourseOverlay } from '../no-exam-course-overlay';

import { mapExamCenterCourseData } from './mapper';
import { ORDER_TYPE } from './utils';

export default function ExamCenterExamCourseList() {
  const { examCenter } = useExamCenter();
  const { code: examCenterCode } = examCenter;

  const [
    { page, pageSize, sortOrder, sortBy },
    { changePageNumber, changePageSize, changeSorting },
  ] = useExamCenterExamCourseListSearchParams();

  const { data: examCenterCoursesData, loading: isLoading } = useAdminSearchExamCenterCoursesQuery({
    variables: {
      searchExamCenterCoursesInput: {
        filter: {
          conditions: [
            {
              field: 'examCenterCode',
              operator: FilterOperator.Equal,
              value: examCenterCode,
            },
          ],
        },
        paging: {
          currentPage: page,
          pageSize,
        },
        order: {
          type: ORDER_TYPE[sortOrder],
          field: sortBy,
        },
      },
    },
    fetchPolicy: 'network-only',
  });

  const examCenterCourses = useMemo(() => {
    return (
      examCenterCoursesData?.ecAdminSearchExamCenterCourses.examCenterCourses.map(
        mapExamCenterCourseData,
      ) ?? []
    );
  }, [examCenterCoursesData]);

  const totalExamCenterCourses = examCenterCoursesData?.ecAdminSearchExamCenterCourses.total ?? 0;

  return (
    <ExamCenterExamCourseDataGrid
      rows={examCenterCourses}
      slots={{
        noRowsOverlay: NoExamCourseOverlay,
      }}
      hideFooter={!totalExamCenterCourses}
      loading={isLoading}
      slotProps={{
        footer: {
          total: totalExamCenterCourses,
          pagination: {
            page,
            count: totalExamCenterCourses,
            rowsPerPage: pageSize,
            onPageChange: (_, page) => {
              changePageNumber(page);
            },
            onRowsPerPageChange: (event) => {
              changePageSize(parseInt(event.target.value));
            },
          },
        },
      }}
      sortingMode='server'
      onSortModelChange={(sorting) => {
        const sortModel = sorting[0];
        if (sortModel?.field && sortModel?.sort) {
          return changeSorting({
            sortOrder: sortModel.sort,
            sortBy: sortModel.field,
          });
        }

        return changeSorting({
          sortOrder: null,
          sortBy: null,
        });
      }}
    />
  );
}
